// 如果发送链接
export function isUrl(url = "") {
  return /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/.test(url);
}

function appendQuery(url, key, value) {
  if (!url || value === undefined || value === null || value === "") {
    return url;
  }

  const hashIndex = url.indexOf("#");
  const hash = hashIndex > -1 ? url.slice(hashIndex) : "";
  const baseUrl = hashIndex > -1 ? url.slice(0, hashIndex) : url;
  const separator = baseUrl.indexOf("?") > -1 ? "&" : "?";

  return `${baseUrl}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}${hash}`;
}

export function getCustomerServiceLink(config = {}) {
  if (Number(config.kf_toggle) !== 1 || !config.kf_link) {
    return "";
  }

  return appendQuery(config.kf_link, "client_type", "h5");
}
